import { useSession } from '@/components/Session/use-session'
import { getKYCState } from '@shared/utils/kycState'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getUserProfile } from '@unx/shared/services/account/user'

export const useAccountQuery = () => {
  const { accessToken } = useSession()

  return useQuery({
    queryKey: ['account'],
    queryFn: async () => {
      return getUserProfile(accessToken)
    },
    enabled: !!accessToken,
  })
}

export const queryOptionsSSRAccount = (accessToken?: string) => {
  return queryOptions({
    queryKey: ['account'],
    queryFn: async () => {
      return getUserProfile(accessToken)
    },
  })
}

export const useKYCData = () => {
  const { data: accountData, isPending } = useAccountQuery()

  return {
    ...getKYCState(accountData?.data),
    isPending,
  }
}

export const useMFAData = () => {
  const { data: accountData } = useAccountQuery()
  const isMfaEnabled = Boolean(accountData?.data?.is2FAEnabled)
  return { isMfaEnabled }
}
